import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnswerAndQuestionComponent } from './answer-and-question/answer-and-question.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { FinishedTestsComponent } from './finished-tests/finished-tests.component';
import { TestDetailComponent } from './test-detail/test-detail.component';
import { ComponentsAdminModule } from '../../../componentsAdmin/components-admin.module';
import { GeneralesComponentsModule } from '../../../../../generales-components/generales-components.module';
import { AnswerDetailComponent } from './answer-detail/answer-detail.component';

const declarations = [
  AnswerAndQuestionComponent,
  FinishedTestsComponent,
  TestDetailComponent,
  AnswerDetailComponent,
];

@NgModule({
  declarations,
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    ComponentsAdminModule,
    GeneralesComponentsModule,
  ],
  exports: declarations,
})
export class TestComponentsModule {}
